import HeroCenteredImage from './HeroCenteredImage';
import HeroAlbumSleeve from './HeroAlbumSleeve';
import HeroSplit from './HeroSplit';
import HeroCinematic from './HeroCinematic';
import HeroDarkCinematic from './HeroDarkCinematic';

const VARIANTS = {
  'hero-centered-image': HeroCenteredImage,
  'hero-album-sleeve': HeroAlbumSleeve,
  'hero-split': HeroSplit,
  'hero-cinematic': HeroCinematic,
  'hero-dark-cinematic': HeroDarkCinematic,
};

export default function HeroSection({ section, data, theme, settings, rsvpRef }) {
  const Variant = VARIANTS[section.variant] || HeroCenteredImage;
  return <Variant section={section} data={data} theme={theme} settings={settings} rsvpRef={rsvpRef} />;
}
